// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BannerWrapperV2_wrapper__clLWh","buttonsWrapper":"BannerWrapperV2_buttonsWrapper__h3nwz","progressBarWrapper":"BannerWrapperV2_progressBarWrapper__UW_G4"};